
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {GatewayOrderExecutionResponse} from './GatewayOrderExecutionResponse';
import {OrderSide} from '../core/OrderSide';
import {FieldModelOrderSide} from '../core/OrderSide';
import {OrderType} from '../core/OrderType';
import {FieldModelOrderType} from '../core/OrderType';
import {OrderTimeInForce} from '../core/OrderTimeInForce';
import {FieldModelOrderTimeInForce} from '../core/OrderTimeInForce';

/**
 * GatewayOrderRequest struct
 */
class GatewayOrderRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!number=} orderId
   * @param {!UUID=} gatewayId
   * @param {!string=} gatewayClientOrderId
   * @param {!string=} gatewaySymbol
   * @param {!OrderSide=} orderSide
   * @param {!OrderType=} orderType
   * @param {!OrderTimeInForce=} orderTimeInForce
   * @param {!number=} volume
   * @param {number=} price
   * @param {!string=} gatewayAccountId
   * @param {!string=} accountGroupName
   * @constructor
   */
  constructor (parent = new Request(), orderId = new UInt64(0, 0), gatewayId = new UUID(), gatewayClientOrderId = '', gatewaySymbol = '', orderSide = new OrderSide(), orderType = new OrderType(), orderTimeInForce = new OrderTimeInForce(), volume = 0.0, price = null, gatewayAccountId = '', accountGroupName = '') {
    super()
    super.copy(parent)
    this.OrderId = orderId
    this.GatewayId = gatewayId
    this.GatewayClientOrderId = gatewayClientOrderId
    this.GatewaySymbol = gatewaySymbol
    this.OrderSide = orderSide
    this.OrderType = orderType
    this.OrderTimeInForce = orderTimeInForce
    this.Volume = volume
    this.Price = price
    this.GatewayAccountId = gatewayAccountId
    this.AccountGroupName = accountGroupName
  }

  /**
   * Copy struct (shallow copy)
   * @this {!GatewayOrderRequest}
   * @param {!GatewayOrderRequest} other Other struct
   * @returns {!GatewayOrderRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.OrderId != null) {
      this.OrderId = UInt64.fromNumber(other.OrderId)
    } else {
      this.OrderId = null
    }
    if (other.GatewayId != null) {
      this.GatewayId = new UUID(other.GatewayId)
    } else {
      this.GatewayId = null
    }
    if (other.GatewayClientOrderId != null) {
      this.GatewayClientOrderId = other.GatewayClientOrderId
    } else {
      this.GatewayClientOrderId = null
    }
    if (other.GatewaySymbol != null) {
      this.GatewaySymbol = other.GatewaySymbol
    } else {
      this.GatewaySymbol = null
    }
    if (other.OrderSide != null) {
      this.OrderSide = OrderSide.fromObject(other.OrderSide)
    } else {
      this.OrderSide = null
    }
    if (other.OrderType != null) {
      this.OrderType = OrderType.fromObject(other.OrderType)
    } else {
      this.OrderType = null
    }
    if (other.OrderTimeInForce != null) {
      this.OrderTimeInForce = OrderTimeInForce.fromObject(other.OrderTimeInForce)
    } else {
      this.OrderTimeInForce = null
    }
    if (other.Volume != null) {
      this.Volume = other.Volume
    } else {
      this.Volume = null
    }
    if (other.Price != null) {
      this.Price = other.Price
    } else {
      this.Price = null
    }
    if (other.GatewayAccountId != null) {
      this.GatewayAccountId = other.GatewayAccountId
    } else {
      this.GatewayAccountId = null
    }
    if (other.AccountGroupName != null) {
      this.AccountGroupName = other.AccountGroupName
    } else {
      this.AccountGroupName = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!GatewayOrderRequest}
   * @returns {!GatewayOrderRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new GatewayOrderRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new GatewayOrderRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!GatewayOrderRequest}
   * @param {!GatewayOrderRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof GatewayOrderRequest)) {
      throw new TypeError('Instance of GatewayOrderRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!GatewayOrderRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      OrderId: ((this.OrderId != null) ? this.OrderId.toNumber() : null),
      GatewayId: ((this.GatewayId != null) ? this.GatewayId.toString() : null),
      GatewayClientOrderId: ((this.GatewayClientOrderId != null) ? this.GatewayClientOrderId : null),
      GatewaySymbol: ((this.GatewaySymbol != null) ? this.GatewaySymbol : null),
      OrderSide: ((this.OrderSide != null) ? this.OrderSide : null),
      OrderType: ((this.OrderType != null) ? this.OrderType : null),
      OrderTimeInForce: ((this.OrderTimeInForce != null) ? this.OrderTimeInForce : null),
      Volume: ((this.Volume != null) ? this.Volume : null),
      Price: ((this.Price != null) ? this.Price : null),
      GatewayAccountId: ((this.GatewayAccountId != null) ? this.GatewayAccountId : null),
      AccountGroupName: ((this.AccountGroupName != null) ? this.AccountGroupName : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return GatewayOrderRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!GatewayOrderRequest} other Object value
   * @returns {!GatewayOrderRequest} Created struct
   */
  static fromObject (other) {
    return new GatewayOrderRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!GatewayOrderRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return GatewayOrderRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!GatewayOrderRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 8011
  }
}

export { GatewayOrderRequest };

/**
 * Fast Binary Encoding GatewayOrderRequest field model
 */
class FieldModelGatewayOrderRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.OrderId = new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.GatewayId = new fbe.FieldModelUUID(buffer, this.OrderId.fbeOffset + this.OrderId.fbeSize)
    this.GatewayClientOrderId = new fbe.FieldModelString(buffer, this.GatewayId.fbeOffset + this.GatewayId.fbeSize)
    this.GatewaySymbol = new fbe.FieldModelString(buffer, this.GatewayClientOrderId.fbeOffset + this.GatewayClientOrderId.fbeSize)
    this.OrderSide = new FieldModelOrderSide(buffer, this.GatewaySymbol.fbeOffset + this.GatewaySymbol.fbeSize)
    this.OrderType = new FieldModelOrderType(buffer, this.OrderSide.fbeOffset + this.OrderSide.fbeSize)
    this.OrderTimeInForce = new FieldModelOrderTimeInForce(buffer, this.OrderType.fbeOffset + this.OrderType.fbeSize)
    this.Volume = new fbe.FieldModelDouble(buffer, this.OrderTimeInForce.fbeOffset + this.OrderTimeInForce.fbeSize)
    this.Price = new fbe.FieldModelOptional(new fbe.FieldModelDouble(buffer, this.Volume.fbeOffset + this.Volume.fbeSize), buffer, this.Volume.fbeOffset + this.Volume.fbeSize)
    this.GatewayAccountId = new fbe.FieldModelString(buffer, this.Price.fbeOffset + this.Price.fbeSize)
    this.AccountGroupName = new fbe.FieldModelString(buffer, this.GatewayAccountId.fbeOffset + this.GatewayAccountId.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelGatewayOrderRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelGatewayOrderRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelGatewayOrderRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.OrderId.fbeSize + this.GatewayId.fbeSize + this.GatewayClientOrderId.fbeSize + this.GatewaySymbol.fbeSize + this.OrderSide.fbeSize + this.OrderType.fbeSize + this.OrderTimeInForce.fbeSize + this.Volume.fbeSize + this.Price.fbeSize + this.GatewayAccountId.fbeSize + this.AccountGroupName.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelGatewayOrderRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.OrderId.fbeExtra + this.GatewayId.fbeExtra + this.GatewayClientOrderId.fbeExtra + this.GatewaySymbol.fbeExtra + this.OrderSide.fbeExtra + this.OrderType.fbeExtra + this.OrderTimeInForce.fbeExtra + this.Volume.fbeExtra + this.Price.fbeExtra + this.GatewayAccountId.fbeExtra + this.AccountGroupName.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelGatewayOrderRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelGatewayOrderRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelGatewayOrderRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 8011
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelGatewayOrderRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelGatewayOrderRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.OrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.GatewayId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GatewayId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayId.fbeSize

    if ((fbeCurrentSize + this.GatewayClientOrderId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GatewayClientOrderId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayClientOrderId.fbeSize

    if ((fbeCurrentSize + this.GatewaySymbol.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GatewaySymbol.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewaySymbol.fbeSize

    if ((fbeCurrentSize + this.OrderSide.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderSide.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderSide.fbeSize

    if ((fbeCurrentSize + this.OrderType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderType.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForce.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderTimeInForce.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForce.fbeSize

    if ((fbeCurrentSize + this.Volume.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Volume.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Volume.fbeSize

    if ((fbeCurrentSize + this.Price.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Price.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Price.fbeSize

    if ((fbeCurrentSize + this.GatewayAccountId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GatewayAccountId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayAccountId.fbeSize

    if ((fbeCurrentSize + this.AccountGroupName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountGroupName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupName.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelGatewayOrderRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelGatewayOrderRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelGatewayOrderRequest}
   * @param {!GatewayOrderRequest} fbeValue Default value, defaults is new GatewayOrderRequest()
   * @returns {!GatewayOrderRequest} GatewayOrderRequest value
   */
  get (fbeValue = new GatewayOrderRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelGatewayOrderRequest}
   * @param {!GatewayOrderRequest} fbeValue GatewayOrderRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.OrderId.fbeSize) <= fbeStructSize) {
      fbeValue.OrderId = this.OrderId.get()
    } else {
      fbeValue.OrderId = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderId.fbeSize

    if ((fbeCurrentSize + this.GatewayId.fbeSize) <= fbeStructSize) {
      fbeValue.GatewayId = this.GatewayId.get()
    } else {
      fbeValue.GatewayId = new UUID()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayId.fbeSize

    if ((fbeCurrentSize + this.GatewayClientOrderId.fbeSize) <= fbeStructSize) {
      fbeValue.GatewayClientOrderId = this.GatewayClientOrderId.get()
    } else {
      fbeValue.GatewayClientOrderId = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayClientOrderId.fbeSize

    if ((fbeCurrentSize + this.GatewaySymbol.fbeSize) <= fbeStructSize) {
      fbeValue.GatewaySymbol = this.GatewaySymbol.get()
    } else {
      fbeValue.GatewaySymbol = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewaySymbol.fbeSize

    if ((fbeCurrentSize + this.OrderSide.fbeSize) <= fbeStructSize) {
      fbeValue.OrderSide = this.OrderSide.get()
    } else {
      fbeValue.OrderSide = new OrderSide()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderSide.fbeSize

    if ((fbeCurrentSize + this.OrderType.fbeSize) <= fbeStructSize) {
      fbeValue.OrderType = this.OrderType.get()
    } else {
      fbeValue.OrderType = new OrderType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderType.fbeSize

    if ((fbeCurrentSize + this.OrderTimeInForce.fbeSize) <= fbeStructSize) {
      fbeValue.OrderTimeInForce = this.OrderTimeInForce.get()
    } else {
      fbeValue.OrderTimeInForce = new OrderTimeInForce()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderTimeInForce.fbeSize

    if ((fbeCurrentSize + this.Volume.fbeSize) <= fbeStructSize) {
      fbeValue.Volume = this.Volume.get()
    } else {
      fbeValue.Volume = 0.0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Volume.fbeSize

    if ((fbeCurrentSize + this.Price.fbeSize) <= fbeStructSize) {
      fbeValue.Price = this.Price.get()
    } else {
      fbeValue.Price = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Price.fbeSize

    if ((fbeCurrentSize + this.GatewayAccountId.fbeSize) <= fbeStructSize) {
      fbeValue.GatewayAccountId = this.GatewayAccountId.get()
    } else {
      fbeValue.GatewayAccountId = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayAccountId.fbeSize

    if ((fbeCurrentSize + this.AccountGroupName.fbeSize) <= fbeStructSize) {
      fbeValue.AccountGroupName = this.AccountGroupName.get()
    } else {
      fbeValue.AccountGroupName = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountGroupName.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelGatewayOrderRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelGatewayOrderRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelGatewayOrderRequest}
   * @param {!GatewayOrderRequest} fbeValue GatewayOrderRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelGatewayOrderRequest}
   * @param {GatewayOrderRequest} fbeValue GatewayOrderRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.OrderId.set(fbeValue.OrderId)
    this.GatewayId.set(fbeValue.GatewayId)
    this.GatewayClientOrderId.set(fbeValue.GatewayClientOrderId)
    this.GatewaySymbol.set(fbeValue.GatewaySymbol)
    this.OrderSide.set(fbeValue.OrderSide)
    this.OrderType.set(fbeValue.OrderType)
    this.OrderTimeInForce.set(fbeValue.OrderTimeInForce)
    this.Volume.set(fbeValue.Volume)
    this.Price.set(fbeValue.Price)
    this.GatewayAccountId.set(fbeValue.GatewayAccountId)
    this.AccountGroupName.set(fbeValue.AccountGroupName)
  }
}

export { FieldModelGatewayOrderRequest };

/**
 * Fast Binary Encoding GatewayOrderRequest model
 */
class GatewayOrderRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelGatewayOrderRequest(this.buffer, 4)
  }

  /**
   * Get the GatewayOrderRequest model
   * @this {!GatewayOrderRequestModel}
   * @returns {!FieldModelGatewayOrderRequest} model GatewayOrderRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!GatewayOrderRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!GatewayOrderRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return GatewayOrderRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!GatewayOrderRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelGatewayOrderRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!GatewayOrderRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!GatewayOrderRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!GatewayOrderRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!GatewayOrderRequestModel}
   * @param {!GatewayOrderRequest} value GatewayOrderRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!GatewayOrderRequestModel}
   * @param {!GatewayOrderRequest} value GatewayOrderRequest value, defaults is new GatewayOrderRequest()
   * @return {!object} Deserialized GatewayOrderRequest value and its size
   */
  deserialize (value = new GatewayOrderRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new GatewayOrderRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new GatewayOrderRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!GatewayOrderRequestModel}
   * @param {!number} prev Previous GatewayOrderRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { GatewayOrderRequestModel };
GatewayOrderRequest.__has_response = true;
GatewayOrderRequest.__response_class = GatewayOrderExecutionResponse;
